import Axios from "@/configs/axios/Axios";
import { GetApiV1Url } from "@/configs/axios/ApiV1";

/**
 * Эти запросы намеренно идут через "голый" Axios, а не через ApiV1:
 * они выполняются до монтирования приложения, когда перехватчик ApiV1
 * ещё не может корректно отработать (router.push затёр бы deep link
 * пользователя, а тосты некому показать — Toast ещё не смонтирован).
 * Поэтому ошибки обрабатываем здесь, локально.
 */

export function langGetFormOptions() {
  return Axios.get(GetApiV1Url("lang/form-options"));
}

export async function authGetUser() {
  try {
    return await Axios.get(GetApiV1Url("auth/user"));
  } catch (e) {
    if (e?.response?.status === 401) {
      localStorage.removeItem("token");
      return null;
    }
    throw e;
  }
}
